import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { BackDrop, FormOption } from "../Modals/AddMeeting";
import { assignMemberToExcoRole, listCouncil } from "../../utils/api-calls";
import { FormSelection } from "../Modals/AddMeeting";
import Loading from "../Loading/Loading";
import {
  ButtonContainer,
  CancelButton,
  Form,
  FormLabel,
  SubCon,
  SubConHeader,
  SubmitButton
} from "./Members.styles";

const AssignExcoRoleModal = ({ close, closeParent, memberId, email, assignedRoles }) => {
  const [selectedRole, setSelectedRole] = useState({});
  const [error, setError] = useState("");

  // Fetch Exco Roles
  const {
    isLoading: rolesLoading,
    data: rolesData
  } = useQuery("exco-roles", listCouncil, {
    refetchOnWindowFocus: false,
    select: (data) => {
      return data
        .filter((item) => !assignedRoles.some((role) => role.id === item.id ))
        .reverse();
    }
  });

  const queryClient = useQueryClient();

  // Assign Exco Role Mutation
  const { mutate, isLoading: submitLoading } = useMutation(
    (data) => assignMemberToExcoRole(data),
    {
      onSuccess: () => {
        toast.success("Successfully assigned to exco role");
        queryClient.invalidateQueries("all-excos");
        queryClient.invalidateQueries("all-members");
        close();
        closeParent();
      },
      onError: () => {
        toast.error("Could not assign to exco role");
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
      
    if (!selectedRole) {
      setError("Exco role is required");
      return;
    }

    mutate({
      member_id: memberId,
      exco_id: selectedRole
    });
  };

  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    setError("");
  };

  return (
    <BackDrop>
      <SubCon>
        <SubConHeader>Add {email} to Exco</SubConHeader>
        {rolesLoading ? (
          <Loading loading={true} />
        ) : (
          <Form onSubmit={handleSubmit}>
            <FormLabel>
              Select exco role:
                <FormSelection
                defaultValue={""}
                onChange={handleRoleChange}
                >
                  <FormOption disabled value="">
                    { rolesData.length === 0 ? "No additional Exco roles available for this member." : "Select an option" }
                  </FormOption>
                  {rolesData.map((item) => (
                    <FormOption key={item.id} value={item.id}>
                      {item.name}
                    </FormOption>
                  ))}
                </FormSelection>
              {error && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {error}
                </span>
              )}
            </FormLabel>

            <ButtonContainer>
              <CancelButton type="button" onClick={close}>
                Cancel
              </CancelButton>
              <SubmitButton 
                type="submit"
                disabled={submitLoading}
              >
                {submitLoading ? "Adding..." : "Add"}
              </SubmitButton>
            </ButtonContainer>
          </Form>
        )}
      </SubCon>
    </BackDrop>
  );
};

export default AssignExcoRoleModal;